<!--eslint-disable vue/no-unused-refs-->
<template>
  <div>
    <div class="selectBox">
      <el-form ref="paramsList" :model="params">
        <QS-search maxLine="2" ref="BLM-search">
          <!-- 内容区域-->
          <el-form-item label="维保单ID" prop="id">
            <el-input
              v-model.trim="params.id"
              clearable
              placeholder="请输入"
              v-number:integer="18"
            />
          </el-form-item>
          <el-form-item label="项目名称ID" prop="itemId">
            <el-select
              v-model="params.itemId"
              filterable
              remote
              clearable
              placeholder="请输入关键词"
              :remote-method="loadProjectData"
            >
            <el-option
                v-for="item in itemIdOptions"
                :key="item.id"
                :label="`${ item.name }(${ item.id })`"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目类型" prop="itemType">
            <el-select
              placeholder="请选择项目类型"
              v-model="params.itemType"
              clearable
            >
              <el-option
                v-for="item in itemTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维保类型" prop="type">
            <el-select
              placeholder="请选择维保类型"
              v-model="params.type"
              clearable
            >
              <el-option
                v-for="item in types"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维保状态" prop="maintenanceState">
            <el-select
              placeholder="全部"
              v-model="params.maintenanceState"
              clearable
            >
              <el-option
                v-for="item in maintenanceStates"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态" prop="settlementState">
            <el-select
              placeholder="全部"
              v-model="params.settlementState"
              clearable
            >
              <el-option
                v-for="item in settlementStates"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合作关系ID" prop="collaborationId">
            <el-input
              v-model.trim="params.collaborationId"
              clearable
              placeholder="请输入"
              v-number:integer="18"
            />
          </el-form-item>

          <el-form-item label="合作服务商名称(ID)" prop="providerId">
            <el-select
              v-model="params.providerId"
              filterable
              remote
              clearable
              placeholder="请输入关键词"
              :remote-method="loadproviderData"
            >
            <el-option
                v-for="item in providerIdOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            </el-form-item>
          <el-form-item label="租赁方案ID" prop="rentPlanId">
            <el-select
              v-model="params.rentPlanId"
              filterable
              remote
              clearable
              placeholder="请输入关键词"
              :remote-method="loadrentPlanData"
            >
            <el-option
                v-for="item in rentPlanIdOptions"
                :key="item.id"
                :label="`${ item.name }(${ item.id })`"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="租赁方案类型" prop="rentPlanType">
            <el-select
              placeholder="请选择租赁方案类型"
              v-model="params.rentPlanType"
              clearable
            >
              <el-option
                v-for="item in rentPlanTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="租赁订单ID" prop="orderId">
            <el-input
              v-model.trim="params.orderId"
              clearable
              placeholder="请输入"
              maxlength="18"
              v-interage="true"
            />
          </el-form-item>
          <el-form-item label="司机名称" prop="customerId">
            <el-select
              v-model="params.customerId"
              filterable
              remote
              clearable
              placeholder="请输入关键词"
              :remote-method="loadcustomerIdData"
            >
            <el-option
                v-for="item in customerIdOptions"
                :key="item.id"
                :label="item.customerName"
                :value="item.id"
              >
                <CustomerNameOptionItem :data="item" />
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 品牌-车系-车型联动选择器 -->
          <CarBrandSeriesModel
            ref="carBrandSeriesModelRef"
            v-model="brandSeriesModel"
            :showModel="true"
            :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
            >
          </CarBrandSeriesModel>
          <el-form-item label="车辆ID" prop="carId">
            <el-input
              v-model.trim="params.carId"
              clearable
              placeholder="请输入"
              maxlength="18"
              v-interage="true"
            />
          </el-form-item>
          <el-form-item label="车牌号" prop="plateNo">
            <el-input
              v-model.trim="params.plateNo"
              clearable
              placeholder="请输入"
              maxlength="18"
            />
          </el-form-item>
          <el-form-item label="vin" prop="vin">
            <el-input
              v-model.trim="params.vin"
              clearable
              placeholder="请输入"
              maxlength="18"
            />
          </el-form-item>

          <el-form-item label="送厂时间" prop="value1">
            <el-date-picker
              v-model="params.value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateTime(params.value1)"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="来源类型" prop="sourceType">
            <el-select
              placeholder="请选择来源类型"
              v-model="params.sourceType"
              clearable
            >
              <el-option
                v-for="item in sourceTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                :loading="oLoading.search"
                type="primary"
                size="small"
                @click="selectBtn"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="Reset"> 重置 </el-button>
            </el-form-item>
            <el-form-item>
              <export
                :exportTemplate="exportTemplate"
                filename="维保管理列表.xlsx"
                :params="params"
                v-if="judgePermission('vehicle_maintenance_list_export_new')"
              ></export>
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <el-button
      type="primary"
      @click="JumpAdd"
      size="small"
      v-if="judgePermission('vehicle_maintenance_list_create_new')"
      >新增维保记录</el-button
    >
    <el-button
      type="primary"
      @click="importBox"
      v-if="judgePermission('vehicle_maintenance_list_batch_import_new')"
      >批量导入</el-button
    >
    <CarMaintenanceList
      :loading="oLoading"
      :params="params"
      ref="CarMaintenanceList"
    />
    <dialog-wrap-upgrade
      ref="batchImport"
      :configOptions="configOptions"
      @close="closeBox"
    >
      <template #uploadMI>
        <el-upload
          class="upload-demo"
          action=""
          :limit="1"
          :http-request="importData"
          :file-list="importDataList"
          :show-file-list="false"
          :autoUpload="true"
          :disabled="uploadLoading"
          v-if="judgePermission('vehicle_maintenance_list_batch_import_new')"
        >
          <el-button :loading="uploadLoading" type="primary">
            导入维保信息
          </el-button>
        </el-upload>
      </template>
      <template #uploadMIList>
        <el-upload
          class="upload-demo ml"
          action=""
          :limit="1"
          :http-request="importPayData"
          :file-list="importPayDataList"
          :show-file-list="false"
          :autoUpload="true"
          :disabled="uploadPayLoading"
          v-if="judgePermission('vehicle_maintenance_list_batch_import_new')"
        >
          <el-button :loading="uploadPayLoading" type="primary">
            导入维保支付项
          </el-button>
        </el-upload>
      </template>
    </dialog-wrap-upgrade>

    <dialogWrap
      v-model="maintenanceUpload.resultShow"
      title="维保信息导入明细"
      :width="'450px'"
      custom-class="dialog-message"
      class="importBox"
    >
      <ul>
        <ol>
          1、本次导入提交完成
        </ol>
        <ol>
          2、导入详情请前往
          <a @click="jumpPage">维保信息导入历史</a
          >，可点击【错误详情】查看错误原因。
        </ol>
      </ul>
    </dialogWrap>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { providerList } from '@/api/domain/carsService'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import {
  maintenanceTemplate,
  maintenancePayTemplate,
} from '@/config'
import CarMaintenanceList from '../components/carMaintenanceList.vue'
import axios from 'axios'
import { getHead } from '@/utils'
import { uploadTaskCreate } from '@/api/currencyApi.js'
import {
  maintenanceLikeByNameApi,
  getCompanyProviderLikeByNameApi,
  getRentPlanNamesApi,
} from './services'
import { searchByCustomerNameSensitive, getCustomerDetailSensitive } from '@/api/domain/customers'
import maintenanceTypes from '@/store/dict/maintenance'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  components: {
    CarMaintenanceList,
    CustomerNameOptionItem,
  },
  data() {
    return {
      customerIdOptions: [],
      rentPlanIdOptions: [],
      providerIdOptions: [],
      itemIdOptions: [],
      itemTypes: maintenanceTypes.projectTypesSource,
      types: [{ label: '维修', value: 1 }, { label: '保养', value: 2 }, { label: '事故', value: 4 }],
      maintenanceStates: [{ label: '已取消', value: -1 }, { label: '待使用', value: 1 }, { label: '维修中', value: 2 }, { label: '已完成', value: 3 }, { label: '退款中', value: -2 }],
      settlementStates: [{ label: '未结算', value: 1 }, { label: '已结算', value: 2 }],
      rentPlanTypes: [{ label: '个人租赁方案', value: 1 }, { label: '企业租赁方案', value: 2 }],
      sourceTypes: [{ label: '系统录入', value: 0 }, { label: '维修厂', value: 1 }, { label: '个人消费', value: 2 }],
      oLoading: {
        fuzzy: false,
        search: false,
      },
      exportTemplate: 'Maintenance',
      params: {
        id: '',
        itemId: '',
        collaborationId: '',
        rentPlanId: '',
        carId: '',
        orderId: '',
        plateNo: '',
        providerId: '',
        maintenanceState: '', // 维保状态  1待维修 2维修中 3已完成
        settlementState: '', // 结算状态  1未结算 2已结算
        type: '', // 维保类型   1维修  2保养
        incomeTimeBegin: '', // 进厂开始时间
        incomeTimeEnd: '', // 进厂结束时间
        value1: '',
        pageSize: 10,
        pageNum: 1,
        modelId: '', // 车型
        sourceType: '', // 来源类型
        vin: '',
        modelName: '',
        seriesName: '',
        brandName: '',
        customerId: '',
        rentPlanType: '',
      },
      brandSeriesModel: {},
      // 下拉框数据
      options: [],
      maintenanceUpload: {
        resultShow: false,
      },
      importDataList: [],
      importPayDataList: [],
      acceptType: ['.xlsx'],
      uploadLoading: false,
      uploadPayLoading: false,

      // 导入功能弹框配置信息
      configOptions: {
        attrs: {
          title: '导入数据',
          width: '1000px',
          // closeOnClickModal: false
        },
        contentConfig: {
          title:
            '这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，若没有制作，请点击下方模板下载按钮',
          describes: [
            '导入前准备:',
            '1.请使用标准模板，确认未进行过任何更改，若无意中修改了模板的原有内容，建议重新下载模板；',
            '2.确保Excel中标题行的名称和表单中与之对应的字段标题一致，且表单中字段名称不能相同；',
            '3.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
            '4.确保Excel中数据格式正确。比如手机号码格式为11位的大陆手机号，日期格式为2020-01-01，日期与数字格式的数据均不能含有中文；',
            '5.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
            '6.Excel多余的列无法导入，请删除Excel中不需要导入的列',
          ],
        },
        footerList: [
          { slotName: 'uploadMI' },
          { slotName: 'uploadMIList' },
          {
            text: '下载维保模板',
            isShowBtn: () => {
              this.judgePermission('vehicle_maintenance_list_batch_export')
            },
            click: () => {
              this.download('maintenance')
            },
            options: {
              type: 'primary',
              class: 'ml',
              // slotName: 'maintenanceDownloadButton',
            },
          },
          {
            text: '下载维保支付项模板',
            isShowBtn: () => {
              this.judgePermission('vehicle_maintenance_list_batch_export')
            },
            click: () => {
              this.download('maintenance_item')
            },
            options: {
              type: 'primary',
              class: 'ml',
            },
          },
        ],
      },
      CAR_MODEL_FILTER_SCENE,
    }
  },
  watch: {
    brandSeriesModel: {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.params.brandId = brandId
        this.params.seriesId = seriesId
        this.params.modelId = modelId
      },
      deep: true,
    },
  },
  created() {
    const { rentPlanId, collaborationId, itemId, id, driverId, type = '', value1 = '', orderId = '', plateNo } = this.$route.query
    if (value1 !== '') {
      this.params.value1 = JSON.parse(value1)
      this.params.incomeTimeBegin = this.params.value1[0]
      this.params.incomeTimeEnd = this.params.value1[1]
    }
    if (type !== '') {
      this.params.type = Number(type)
    }
    if (orderId !== '') {
      this.params.orderId = Number(orderId)
    }
    this.params.rentPlanId = Number(rentPlanId) || ''
    this.params.collaborationId = Number(collaborationId) || ''
    this.params.itemId = Number(itemId) || ''
    this.params.carId = Number(id) || ''
    this.params.customerId = Number(driverId) || ''
    this.params.plateNo = plateNo || ''
    // 解决司机名称回显司机id，无法显示司机姓名问题
    if (this.params.customerId) {
      this.getCustomerDetail(this.params.customerId)
    }
    this.loadProjectData()
    this.loadrentPlanData()
  },
  mounted() {
    this.getProvider()
    this.$refs['BLM-search'].searchMoreClick()
  },
  methods: {
    loadcustomerIdData(name) {
      this.getDriversLikeByName(name)
    },
    async getDriversLikeByName(name) {
      if (name.length < 1) return
      const [err, _data] = await this.$to(searchByCustomerNameSensitive({
        customerName: name,
        mixedType: 'YES',
      }))
      if (!err) {
        const { code } = _data
        let { data } = _data
        if (code === 1) {
          if (!Array.isArray) data = []
          this.customerIdOptions = data
        }
      }
    },
    loadrentPlanData(name) {
      this.getRentPlanLikeByNames(name)
    },
    // 租赁方案名称
    async getRentPlanLikeByNames(name) {
      const [err, _data] = await this.$to(getRentPlanNamesApi({ name }))
      if (!err) {
        const { code } = _data
        let { data } = _data
        if (code === 1) {
          if (!Array.isArray) data = []
          this.rentPlanIdOptions = data
        }
      }
    },
    loadproviderData(name) {
      this.getCompanyProviderLikeByName(name)
    },
    // 获取服务商名称
    async getCompanyProviderLikeByName(name) {
      const [err, _data] = await this.$to(
        getCompanyProviderLikeByNameApi({ name }),
      )
      if (!err) {
        const { code } = _data
        let { data } = _data
        if (code === 1) {
          if (!Array.isArray) data = []
          this.providerIdOptions = data.map((item) => ({
            ...item,
            name: `${item.name}(${item.id})`,
          }))
        }
      }
    },
    // 项目名称
    loadProjectData(name) {
      this.getMaintenanceLikeByNameApi(name)
    },
    // 项目名称模糊查询
    async getMaintenanceLikeByNameApi(name) {
      const [err, _data] = await this.$to(maintenanceLikeByNameApi({ name }))
      if (!err) {
        const { code } = _data
        let { data } = _data
        if (code === 1) {
          if (!Array.isArray) data = []
          this.itemIdOptions = data
        }
      }
    },
    // 下载逻辑
    download(type) {
      const downloadData = {
        maintenance_item: maintenancePayTemplate,
        maintenance: maintenanceTemplate,
      }

      window.location.href = downloadData[type]
    },
    /* 获取修理厂名单 */
    async getProvider() {
      try {
        const data = await providerList({
          serviceType: 1,
          state: 1,
        })
        this.options = data.data.items
      } catch (error) {
        console.log(error)
      }
    },
    /* 新增 */
    JumpAdd() {
      this.$router.push({ path: '/vehicle/maintenance/add' })
    },
    /* 拆分送厂时间 */
    dateTime(data) {
      if (data) {
        this.params.incomeTimeBegin = data[0]
        this.params.incomeTimeEnd = data[1]
      } else {
        this.params.incomeTimeBegin = ''
        this.params.incomeTimeEnd = ''
      }
    },

    /* 查询 */
    selectBtn() {
      if (this.params.id) {
        this.params.id = parseInt(this.params.id)
      }
      this.$refs.CarMaintenanceList.paginationEvent({
        pagination: {
          pageSize: this.params.pageSize,
          pageNum: 1,
        },
      })
    },
    /* 重置 */
    Reset() {
      this.$refs.paramsList.resetFields()
      Object.keys(this.params).forEach((item) => {
        if (!['pageNum', 'pageSize'].includes(item)) {
          this.params[item] = ''
        }
      })
      this.$refs.carBrandSeriesModelRef.reset()
      this.brandSeriesModel = {}
      this.params.expenseBearingPartys = []
      this.$nextTick(() => {
        this.selectBtn()
      })
    },
    // 导入弹窗
    importBox() {
      this.$refs.batchImport.showDialog()
    },
    // 关闭导入弹窗
    closeBox() {
      this.uploadLoading = false
      this.uploadPayLoading = false
      this.importDataList = []
      this.importPayDataList = []
    },
    // 导入维保数据
    importData({ file }) {
      this.uploadLoading = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'vehicle')
      formData.append('code', 'vehicle_maintenance_guarantee_slip_file')

      const size = file.size / (1024 * 1024)
      const type = this.getFileType(file.name)
      if (!this.acceptType.includes(type.toLowerCase())) {
        this.$message.error('导入文件格式有误')
        this.importDataList = []
        this.uploadLoading = false
      } else if (size > 50) {
        this.$message.error('文件大小不能超过 50M')
        this.importDataList = []
        this.uploadLoading = false
      } else {
        axios({
          url: '/admin/v1/vehicle/fs/standard/upload',
          method: 'POST',
          data: formData,
          headers: {
            ...this.headers,
            ...getHead(this.$store),
          },
          onUploadProgress: () => {
            this.isProgress = true
            this.disabled = true
          },
        })
          .then(({ data: { code, data, msg } }) => {
            if (code === 1) {
              // this.maintenanceUpload.resultShow = true
              // uploadType :  维保信息-导入数据 34 维保项目-维保支付项 35
              uploadTaskCreate({
                uploadType: '34',
                fileAddress: data,
                fileName: file.name,
              })
                .then((result) => {
                  if (result.code === 1) {
                    this.maintenanceUpload.resultShow = true
                    this.uploadLoading = false
                    this.importDataList = []
                  }
                })
                .catch(() => {
                  this.uploadLoading = false
                  this.importDataList = []
                })
            } else {
              this.uploadLoading = false
              this.importDataList = []
              this.$message.error(msg)
            }
          })
          .catch(() => {
            this.importDataList = []
            this.uploadLoading = false
          })
      }
    },
    // // 导入维保支付项数据
    importPayData({ file }) {
      this.uploadPayLoading = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'finance')
      formData.append('code', 'finance_maintenance_payment_file')

      const size = file.size / (1024 * 1024)
      const type = this.getFileType(file.name)
      if (!this.acceptType.includes(type.toLowerCase())) {
        this.$message.error('导入文件格式有误')
        this.importPayDataList = []
        this.uploadPayLoading = false
      } else if (size > 50) {
        this.$message.error('文件大小不能超过 50M')
        this.importPayDataList = []
        this.uploadPayLoading = false
      } else {
        axios({
          url: '/admin/v1/vehicle/fs/standard/upload',
          method: 'POST',
          data: formData,
          headers: {
            ...this.headers,
            ...getHead(this.$store),
          },
          onUploadProgress: () => {
            this.isProgress = true
            this.disabled = true
          },
        })
          .then(({ data: { code, data, msg } }) => {
            if (code === 1) {
              // uploadType :  维保信息-导入数据 34 维保项目-维保支付项 35
              uploadTaskCreate({
                uploadType: '35',
                fileAddress: data,
                fileName: file.name,
              })
                .then((result) => {
                  if (result.code === 1) {
                    this.maintenanceUpload.resultShow = true
                    this.uploadPayLoading = false
                    this.importPayDataList = []
                  }
                })
                .catch(() => {
                  this.uploadPayLoading = false
                  this.importPayDataList = []
                })
            } else {
              this.uploadPayLoading = false
              this.importPayDataList = []
              this.$message.error(msg)
            }
          })
          .catch(() => {
            this.importPayDataList = []
            this.uploadPayLoading = false
          })
      }
    },

    getFileType(file) {
      if (file) {
        return file.slice(file.lastIndexOf('.'))
      } else {
        return ''
      }
    },
    // 页面跳转
    jumpPage() {
      this.maintenanceUpload.resultShow = false
      this.$refs.batchImport.close()
      this.$router.push({ name: 'maintenanceImportHistory' })
    },
    // 根据司机id查询司机信息
    async getCustomerDetail(id) {
      const [err, _data] = await this.$to(getCustomerDetailSensitive({
        id,
      }))
      if (!err) {
        const { code, data } = _data
        if (code === 1 && data) {
          this.customerIdOptions = [data]
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.el-tabs {
  font-size: 14px;
}
.selectBox {
  margin-bottom: 20px;
  .btnText {
    padding-top: 5px;
    font-size: 14px;
    color: #2e7eff;
  }
}
.content {
  max-height: 500px;
  padding: 0;
  font-size: 14px;
}
.alertBox1 {
  ::v-deep .el-form-item--small {
    display: flex;
    align-items: center;
  }
  .el-form-item {
    ::v-deep .el-form-item__label {
      width: 110px;
    }
  }
  .el-input {
    width: 200px;
  }
}
.alertBox2 {
  ::v-deep .el-form-item--small {
    display: flex;
    align-items: center;
  }
  .el-form-item {
    ::v-deep .el-form-item__label {
      width: 110px;
    }
  }
}
::v-deep .el-range-separator {
  width: 20px !important;
}
::v-deep .el-dialog__body {
  font-size: 14px;
  color: #323233;
}
.importBox {
  font-size: 14px;
  color: #323233;
  ul,
  ol {
    margin: 0;
    padding: 0;
  }
  header {
    margin-bottom: 8px;
  }
  ul {
    margin-bottom: 16px;
    margin-top: 8px;
  }

  .uploadBtn {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    .ml {
      margin-left: 10px;
    }
  }
}
</style>
